export { default } from './Portal';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/Portal/index.js
// module id = 318
// module chunks = 25